/**
 * Nearby Vuex
 */
import * as API from '@/endpoints'
import Axios from 'axios'
import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    directory: {
      worldDirectory: {
        data: {},
        isLoading: false
      },
      regionalOffices: {
        data: {},
        isLoading: false
      },
      recruitmentAgency: {
        data: {},
        isLoading: false
      }
    },
    subDirectory: {
      worldDirectory: {
        data: {},
        isLoading: false
      },
      regionalOffices: {
        data: {},
        isLoading: false
      },
      recruitmentAgency: {
        data: {},
        isLoading: false
      }
    }
  },
  mutations: {
    setDirectory (state, v) {
      if (v.type === 'world_directory') { Vue.set(state.directory.worldDirectory, 'data', v.data) }
      if (v.type === 'recruiting_agencies') { Vue.set(state.directory.recruitmentAgency, 'data', v.data) }
      if (v.type === 'regional_offices') { Vue.set(state.directory.regionalOffices, 'data', v.data) }
    },
    setDirectoryLoader (state, v) {
      if (v.type === 'world_directory') { Vue.set(state.directory.worldDirectory, 'isLoading', v.data) }
      if (v.type === 'recruiting_agencies') { Vue.set(state.directory.recruitmentAgency, 'isLoading', v.data) }
      if (v.type === 'regional_offices') { Vue.set(state.directory.regionalOffices, 'isLoading', v.data) }
    },
    setSubDirectory (state, v) {
      if (v.type === 'world_directory') { Vue.set(state.subDirectory.worldDirectory, 'data', v.data) }
      if (v.type === 'recruiting_agencies') { Vue.set(state.subDirectory.recruitmentAgency, 'data', v.data) }
      if (v.type === 'regional_offices') { Vue.set(state.subDirectory.regionalOffices, 'data', v.data) }
    },
    setSubDirectoryLoader (state, v) {
      if (v.type === 'world_directory') { Vue.set(state.subDirectory.worldDirectory, 'isLoading', v.data) }
      if (v.type === 'recruiting_agencies') { Vue.set(state.subDirectory.recruitmentAgency, 'isLoading', v.data) }
      if (v.type === 'regional_offices') { Vue.set(state.subDirectory.regionalOffices, 'isLoading', v.data) }
    }
  },
  actions: {
    getSubItems ({ commit, dispatch }, { type, query }) {
      return new Promise((resolve, reject) => {
        commit('setSubDirectoryLoader', { type, data: true })
        Axios.get(API.endpoints.items + '?type=directory' + query).then(
          res => {
            commit('setSubDirectory', { type, data: res.data })
            commit('setSubDirectoryLoader', { type, data: false })
            resolve(res.data)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            commit('setSubDirectoryLoader', { type, data: false })
            reject(error)
          }
        )
      })
    },
    getdirectory ({ commit, dispatch }, { type }) {
      return new Promise((resolve, reject) => {
        commit('setDirectoryLoader', { type, data: true })
        Axios.get(API.endpoints.directory + '/type?type=' + type).then(
          res => {
            commit('setDirectory', { type, data: res.data })
            commit('setDirectoryLoader', { type, data: false })
            resolve(res.data)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            commit('setDirectoryLoader', { type, data: false })
            reject(error)
          }
        )
      })
    }
  }
}
